<template>
    <div class="employee_list table_outter_block" ref="table_outter">
        <MyTransition :myName="'up'">
            <Popup v-if="popupStatus">
                <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
                <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
            </Popup>
        </MyTransition>
        <div class="label">
            <Div>
                <span>A</span>
                <p>承攬商意外險(團體保險)投保證明</p>
            </Div>
            <Div>
                <span>B</span>
                <p>勞工安全衛生教育訓練證明(六小時)</p>
            </Div>
            <Div>
                <span>C</span>
                <p>承攬商危害告知課程測驗成績審核</p>
            </Div>
        </div>
        <Table ref="table" :column="thead" :fixedColumn="fixedColumn" :data="data" :type="type" :tableHeight="tableHeight"
            :pageHeight="pageHeight" @create="createCode" @receive="receive" @employeeDelete="employeeDelete"
            @cancleCard="cancleCard" @delPaper="delPaper"></Table>
    </div>
</template>
<style lang="scss">
.employee_list {
    .label {
        width: 100%;
        font-size: 12px;

        div {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            margin: 5px 0;
            color: #888;

            span {
                font-weight: bold;
            }

            p {
                text-align: right;
                width: 210px;
            }
        }
    }
}
</style>
<script>
import Table from "@/components/Table.vue";
export default {
    name: "employeeList",
    data() {
        return {
            data: [],
            type: "contractor-employee",
            tableHeight: null,
            pageHeight: 50,
            thead: [
                {
                    name: "操作",
                    width: "45px",
                    val: "action",
                    type: "action",
                    align: "center"
                },
                {
                    name: "職員姓名",
                    width: "120px",
                    val: "name",
                    type: "text",
                    align: "left"
                },
                {
                    name: "在職",
                    width: "100px",
                    type: "boolean",
                    val: "status",
                    align: "center"
                },
                {
                    name: "合格證狀態",
                    width: "100px",
                    type: "boolean",
                    val: "code_result",
                    align: "center"
                },
                {
                    name: "合格證號",
                    width: "150px",
                    val: "code",
                    type: "text",
                    align: "left"
                },
                {
                    name: "已領證",
                    width: "80px",
                    val: "is_receive",
                    type: "boolean",
                    align: "center"
                },
                {
                    name: "A",
                    width: "45px",
                    val: "accident_insurance_result",
                    type: "boolean",
                    align: "center"
                },
                {
                    name: "A到期時間",
                    width: "100px",
                    val: "accident_insurance_expiry_date",
                    type: "text",
                    align: "left"
                },
                {
                    name: "B",
                    width: "45px",
                    val: "training_result",
                    type: "boolean",
                    align: "center"
                },
                {
                    name: "B到期時間",
                    width: "100px",
                    val: "training_expiry_date",
                    type: "text"
                },
                {
                    name: "C",
                    width: "45px",
                    type: "boolean",
                    val: "score_result",
                    align: "center"
                },
                {
                    name: "考試通過狀態",
                    width: "120px",
                    val: "score",
                    type: "text",
                    align: "left"
                }
            ],
            fixedColumn: ["action", "name"],
            popupStatus: false,
            successText: null,
            popup: null
        };
    },
    components: {
        Table
    },
    computed: {
        vendorId() {
            return this.$route.query.vendorId;
        },
        vendorId_login() {
            return this.$store.state.user.id;
        }
    },
    methods: {
        getData() {
            // 判斷身份
            if (this.$store.state.user.role == "vendor") {
                this.$http.api.admin
                    .venderEmployee(this.vendorId_login)
                    .then(res => {
                        this.data = res.data;
                    });
            } else if (
                this.$store.state.user.role == "manager" ||
                this.$store.state.user.role == "department"
            ) {
                this.$http.api.admin.venderEmployee(this.vendorId).then(res => {
                    this.data = res.data;
                });
            }
        },
        createCode(val) {
            this.$http.api.admin
                .makeCode(val.employee_id)
                .then(res => {
                    this.popupStatus = true;
                    this.successText = "成功";
                    this.popup = "success";
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = "核發失敗";
                });
        },
        receive(item) {
            this.$http.api.admin
                .getReceive(item.employee_id)
                .then(res => {
                    // this.popupStatus = true;
                    // this.successText = "成功";
                    // this.popup = "success";
                    this.getData();
                    this.$refs.table.tableMenu.index = null;
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = "領證失敗";
                });
        },
        poupupEnter() {
            this.popupStatus = false;
            if (this.successText == "成功") {
                this.getData();
            }
            this.$refs.table.tableMenu.index = null;
        },
        delPaper(item) {
            this.$http.api.admin
                .clearPaper({
                    employee_id: item.employee_id,
                    course_id: item.course_id
                })
                .then(res => {
                    this.popupStatus = true;
                    this.successText = "成功";
                    this.popup = "success";
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = "刪除失敗";
                });
        },
        employeeDelete(item) {
            console.log(item)
            const yes = confirm(`確認刪除${item.name}嗎？`);
            if (yes) {
                this.$http.api.admin
                    .deleteEmployee({
                        id: item.employee_id
                    })
                    .then(res => {
                        this.popupStatus = true;
                        this.successText = "成功";
                        this.popup = "success";
                    })
                    .catch(error => {
                        this.popupStatus = true;
                        this.popup = "error";
                        this.successText = "刪除失敗";
                    });
            }


        },
        cancleCard(item) {
            this.$http.api.admin
                .cancelReceive(item.employee_id)
                .then(res => {
                    // this.popupStatus = true;
                    // this.successText = "成功";
                    // this.popup = "success";
                    this.getData();
                    this.$refs.table.tableMenu.index = null;
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.popup = "error";
                    this.successText = "取消失敗";
                });
        },
    },
    mounted() {
        this.getData();
        this.$nextTick(() => {
            this.tableHeight =
                this.$refs.table_outter.offsetHeight - this.pageHeight;
        });
    }
};
</script>
